import React, {FC} from 'react';

import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { TLineItemProps } from "../types/ExploreEquipment.types";

import "../style.scss"

const LineItem : FC<TLineItemProps> = ({url, lineItem}) => (
    // TO DO: Replace anchor tag with RoutableSitecoreLink when issue with Layout Service 404 error is fixed
    // <Link field={{value: {href:url}}} className="explore-equipment__line-item" editable={false}>
    <a href={url} className="explore-equipment__line-item">
        <div className="explore-equipment__line-item__image-wrapper">
            <img  src={lineItem?.bigthumbnail} alt={lineItem?.bigthumbnailAlt || ''} loading="lazy" className='explore-equipment__line-item__image'/>
        </div>
        <h3 className="explore-equipment__line-item__title">{lineItem.title}</h3>
        <RichText field={{value: lineItem.description}} className="explore-equipment__line-item__text" tag="div" editable={false} />
    </a>
    // </Link>
);

export default LineItem;